import React, { forwardRef } from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import Fields from './fields'

const Content = styled.div`
  padding: 1.5rem 0;
  :last-child {
    border: none;
  }
  border-bottom: 1px solid #e7e7e7;
`
const Title = styled.div`
  border-left: solid 4px rgb(var(--ow-primary-color));
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 1.5rem;
  ${tw`pl-2 h-4 flex items-center`}
`

const Group = function (
  {
    formControl,
    content,
    isActive,
    data,
    fields,
    editableFields,
    useScrollIntoView,
    widgets,
    detailData,
    waterMarkDefs,
    isHiddenMedia,
    refConditonFields,
  },
  ref
) {
  const { title } = content
  const { targetRef } = useScrollIntoView
  const props = {}
  if (isActive && targetRef) {
    props.ref = targetRef
  }

  if (content.fields && (content.fields.children || []).length === 0) {
    return null
  }

  return (
    <Content {...props}>
      {title && <Title>{title}</Title>}
      <Fields
        data={data}
        formControl={formControl}
        layout={content.fields}
        fields={fields}
        editableFields={editableFields}
        widgets={widgets}
        ref={ref}
        detailData={detailData}
        isHiddenMedia={isHiddenMedia}
        waterMarkDefs={waterMarkDefs}
        refConditonFields={refConditonFields}
      />
    </Content>
  )
}

export default forwardRef(Group)
